import { ButtonSecondary } from '@anwb/poncho/components/button';
import Panel from '@anwb/poncho/components/panel';
import Typography from '@anwb/poncho/components/typography';

export const CrossSell = () => (
	<Panel variant="informative" isPromotional dataTest="car-sales-service-cross-sell">
		<Panel.Media
			image={{
				src: 'https://merk.anwb.nl/m/1496af9856d4292b/Web_760-autoverkoopservice.jpg',
				alt: 'ANWB Car Sales Service verkocht',
			}}
		/>

		<Panel.Header title="Je auto verkopen?" />
		<Panel.Content>
			<Typography variant="body-text">
				Je auto verkopen zonder ongemakkelijke onderhandelingen? Ontvang gratis een gegarandeerde
				prijs voor je auto.
			</Typography>
			<ButtonSecondary
				className="more_information"
				data-test="car-sales-service-cross-sell-button"
				href="/auto/verkopen/verkoopservice"
				// @ts-ignore
				target="_blank"
				rel="noreferrer"
			>
				Meer informatie
			</ButtonSecondary>
		</Panel.Content>
	</Panel>
);
